import React, { useState, useEffect } from 'react';
//Router
import { Link } from 'react-router-dom';
//ANTD
import { Button, Checkbox, Divider } from 'antd';
//COMPONENTS
import TourItem from '../components/tourItem';
import EmptyTabList from './emptyTabList';

import { FormattedMessage } from 'react-intl';
import { Type } from 'app/constants/TourPoints';
import TransferButton from './transferButton';
import { TRASFER_GPS_TABS } from '../../../../constants/transfer.constants';
import { MultiDayTourItem } from '../components/multiDayTourItem';
const CheckboxGroup = Checkbox.Group;

const DownloadTab = (props) => {
  const { setDownloadCheckedList, downloadTourGps, downloadCheckedList } =
    props;
  const defaultCheckedList = () => {
    const partsData = [];
    const mainData = downloadTourGps.data.map((item) => {
      if (item.multiDay === true) {
        item.parts.map((part) => partsData.push(+part.id));
      } else {
        return +item.id;
      }
    });
    return [...mainData, ...partsData].filter((n) => n);
  };
  const initState = {
    checkedList: defaultCheckedList(),
    indeterminate: false,
    checkAll: true,
  };

  const [state, updateState] = useState(initState);

  useEffect(() => {
    setDownloadCheckedList(defaultCheckedList());
  }, []);

  useEffect(() => {
    if (state.checkAll) {
      setDownloadCheckedList(defaultCheckedList());
      updateState({ ...state, checkedList: defaultCheckedList() });
    } else {
      updateState({
        ...state,
        indeterminate:
          defaultCheckedList().length < downloadTourGps.data.length,
        checkAll: defaultCheckedList().length === downloadTourGps.data.length,
      });
    }
  }, [downloadTourGps.data.length]);

  const onCheckAllChange = (e) => {
    updateState({
      checkedList: e.target.checked ? defaultCheckedList() : [],
      indeterminate: false,
      checkAll: e.target.checked,
    });
    setDownloadCheckedList(e.target.checked ? defaultCheckedList() : []);
  };

  const onChange = (checkedList) => {
    updateState({
      checkedList,
      indeterminate:
        !!checkedList.length &&
        checkedList.length < defaultCheckedList().length,
      checkAll: checkedList.length === defaultCheckedList().length,
    });
    setDownloadCheckedList(checkedList);
  };

  const getScope = (item) =>
    item.scope
      ? item.scope
      : item.type &&
        item.type !== Type.START &&
        item.type !== Type.END &&
        item.type !== Type.VIA &&
        item.type !== Type.DRAG
      ? item.type
      : typeof item.stickToRoad === 'function'
      ? 'tourpoint'
      : 'tour';

  return (
    <React.Fragment>
      <div
        className="listDownlaodTour"
        style={props.getListStyleIE(downloadCheckedList.length)}
      >
        {downloadTourGps.data.length === 0 ? (
          <EmptyTabList />
        ) : (
          <React.Fragment>
            <div className="site-checkbox-all-wrapper">
              <Checkbox
                indeterminate={state.indeterminate}
                onChange={onCheckAllChange}
                checked={state.checkAll}
              >
                <FormattedMessage id="Check all" defaultMessage="Check all" />
              </Checkbox>
            </div>
            <Divider style={{ margin: '3px 0' }} />

            <CheckboxGroup value={state.checkedList} onChange={onChange}>
              {downloadTourGps.data.map((item) => {
                const isLinkEnabled = getScope(item) !== 'tourpoint';
                if (item.multiDay === true) {
                  return (
                    <MultiDayTourItem
                      item={item}
                      key={item.id}
                      checkedList={downloadCheckedList}
                      setCheckedList={onChange}
                      defaultCheckedList={defaultCheckedList()}
                      deleteAvailable
                      {...props}
                    />
                  );
                } else {
                  return (
                    <Checkbox value={+item.id} key={item.id}>
                      <TourItem
                        item={item}
                        deleteAvailable
                        isLinkEnabled={isLinkEnabled}
                        {...props}
                        key={item.id}
                      />
                    </Checkbox>
                  );
                }
              })}
            </CheckboxGroup>
          </React.Fragment>
        )}
      </div>
      <TransferButton
        hanleClick={() =>
          props.transferRoutes(
            downloadTourGps.data,
            downloadCheckedList,
            TRASFER_GPS_TABS.DOWNLOAD
          )
        }
        isDisabled={state.checkedList.length === 0} //temporary for testing
        isDetectedTT={props.isDetectedTT}
      />
    </React.Fragment>
  );
};

export default DownloadTab;
